import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button, Form, Image } from "react-bootstrap";
import { apiGetEmission, apiSaveEmission, apiUpdateEmission } from "../../../api/ApiEmission";
import { useSelector } from "react-redux";
import { MdDelete } from "react-icons/md";
import ModalCropImage from "../../layout/ModalCropImage";

const ModalCreateUpdate = (props) => {
  const { t } = useTranslation();
  const { id, show, handleClose, handleRecupDatas, prochainIndice } = props; // eslint-disable-line no-unused-vars
  const initialState = {
    nom: "",
    description: "",
    URL: "",
    publie: true,
    ordre: prochainIndice,
    datePublication: "",
    type: "emission",
    cardPic: "",
  };
  const [state, setState] = useState(initialState);
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);

  const [image, setImage] = useState("");
  const [croppedImage, setCroppedImage] = useState("");
  const [showModalCrop, setShowModalCrop] = useState(false);

  const recupData = async () => {
    const res = await apiGetEmission(ReduxInstance._id, id);
    let emissionCache = res.data;
    let date = new Date(emissionCache.datePublication);
    emissionCache.datePublication =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) +
      "-" +
      (date.getDate() < 10 ? "0" + date.getDate() : date.getDate());
    if (emissionCache.datePublication === "1970-01-01") {
      emissionCache.datePublication = "";
    }

    setState(emissionCache);
  };

  const submitData = async () => {
    let form_data = new FormData();

    if (id) {
      if (image) {
        form_data.append("cardPic", croppedImage);
      } else if (state.cardPic === "") {
        form_data.append("cardPic", "");
      }

      /* UPDATE FOR DATAS  */
      await apiUpdateEmission(id, state);
      /* UPDATE FOR IMAGE  */
      await apiUpdateEmission(id, form_data);
    } else {
      const retourSave = await apiSaveEmission(ReduxInstance._id, state);
      if (image) {
        /* UPDATE FOR IMAGE  */
        form_data.append("cardPic", croppedImage);
        await apiUpdateEmission(retourSave.data._id, form_data);
      }
    }
    handleRecupDatas();
    emptyImage();
    handleClose();
  };

  const onSelectedFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImage(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      setShowModalCrop(true);
    }
  };

  const handleCloseCrop = () => {
    setShowModalCrop(false);
  };

  const emptyImage = () => {
    setImage("");
    setCroppedImage("");
    setState({ ...state, cardPic: "" });
    const inputFile = document.getElementById("formBasicImage");
    if (inputFile) {
      inputFile.value = "";
    }
  };

  const handleSetCrop = (_croppedImage) => {
    // setState({ ...state, cardPic: _croppedImage })
    setCroppedImage(_croppedImage);
  };

  useEffect(() => {
    if (id) recupData();
    else {
      setState(initialState);
      setImage("");
      setCroppedImage("");
    }
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!id) setState(initialState);
  }, [prochainIndice]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {state._id ? t("admin.PageAdminMedias.modifier") : t("admin.PageAdminMedias.ajouter")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <label className="mt-2">{t("commun.form.label.intitule1")}</label>
          <Form.Control
            type="text"
            name="nom"
            value={state.nom}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />

          <label className="mt-2">{t("commun.form.label.description")}</label>
          <Form.Control
            type="text"
            as="textarea"
            name="description"
            value={state.description}
            rows={3}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />

          <label className="mt-2">{t("commun.form.label.typeMedia")}</label>
          <Form.Select
            name="type"
            value={state.type}
            onChange={(e) => {
              setState({ ...state, [e.target.name]: e.target.value });
            }}
          >
            <option value="emission">{t("commun.form.select.emission")}</option>
            <option value="podcast">{t("commun.form.select.podcast")}</option>
          </Form.Select>

          <label className="mt-2">{t("commun.form.label.datePublication")}</label>
          <Form.Control
            type="date"
            name="datePublication"
            value={state.datePublication}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />

          <label className="mt-2">{t("commun.form.label.url")}</label>
          <Form.Control
            type="text"
            name="URL"
            value={state.URL}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />

          {croppedImage ? (
            <div>
              <div className="mt-2">{t("commun.form.label.image")}</div>
              <Image src={URL.createObjectURL(croppedImage)} width={240} />
              <span role="button" onClick={() => emptyImage()}>
                <MdDelete size="1.5em" />
              </span>
            </div>
          ) : state.cardPic ? (
            <div>
              <div className="mt-2">{t("commun.form.label.image")}</div>
              <Image
                width={240}
                src={process.env.REACT_APP_URL_EXPRESS + "images/media/" + state.cardPic}
              />
              <span role="button" onClick={() => emptyImage()}>
                <MdDelete size="1.5em" />
              </span>
            </div>
          ) : (
            <div>
              <label className="mt-2">{t("commun.form.label.image")}</label>
              <Form.Control type="file" accept="image/*" onChange={onSelectedFile} />
            </div>
          )}

          <label className="mt-2">{t("commun.form.label.publier")}</label>
          <Form.Check
            role="button"
            type="switch"
            id={"switch" + id}
            label={state.publie ? t("commun.form.button.oui") : t("commun.form.button.non")}
            name="publie"
            onChange={(e) => setState({ ...state, [e.target.name]: !state.publie })}
            checked={state.publie ? "checked" : ""}
          />
        </Form>
        <ModalCropImage
          show={showModalCrop}
          image={image}
          handleClose={handleCloseCrop}
          resetImage={emptyImage}
          setImageCropped={handleSetCrop}
          xRatio={480}
          yRatio={360}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          {t("commun.form.button.annuler")}
        </Button>
        <Button variant="success" onClick={submitData}>
          {state._id ? t("commun.form.button.modifier") : t("commun.form.button.ajouter")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCreateUpdate;
